export default "__VITE_ASSET__CoN7Hn0I__"